import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { Element } from "@xmpp/xml"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import VCardParser from "@/lib/VCardParser"
import { Profile } from "@/reducers/profilesSlice"

const NODE = "urn:slickshift:account:users:0"

export const retrieveAllUsersVCards = async (
  xmpp: Client,
): Promise<Array<Profile | undefined>> => {
  const users = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: NODE,
    timeout: 4000,
  })

  const items = users
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item") as [Element]

  return items.map((item) => {
    const user = item.getChild("user", "urn:slickshift:account:0")
    if (!user) return undefined
    const vCard = VCardParser.parse(user)
    if (!vCard) return undefined
    const preferredLanguage =
      user.getChildText("preferredLanguage") || undefined
    const disabledEl = user.getChild("disabled", "urn:slickshift:account:0")
    const disabled = disabledEl?.getText()?.toLowerCase() === "true"
    return {
      ...vCard,
      jid: item.getAttr("id") as string,
      ...(preferredLanguage && { preferredLanguage }),
      ...(disabled && { disabled: true }),
    }
  })
}

export const subscribeToUsersVCards = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(window.XMPP!, wizardJid(client.jid!), NODE)
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      console.warn(`Error subscribing to ${NODE}`, error)
    }
  }
}
